import Select from 'react-select';
import Translation from '../Translation/cont/Translation';

const SignageFilterSelect = ({form, field, filterItems, id}) => {
    const sortedFilterItems = _.keys(filterItems).sort(function(a, b){return a-b})
    let options = []

    
    const selectSettings = {
        menuShouldBlockScroll:true,
        isClearable:true,
        className:'select-container',
        isSearchable:false,
        classNamePrefix:"select"
    }
    
    sortedFilterItems.map((filterID) => {
        const value = filterID
        let label = filterItems[filterID].name
        
        if(id === 'fsk') {
            label = 'FSK ' + filterItems[filterID].name
            options.push({value,label})
        } else {
            options.push({value,label})
        }
    })
    
    const onChange = (option, id) => {
        if(!option) {
            form.setFieldValue(field.name, "")
        } else {
            form.setFieldValue(field.name, option.value)
        }
    }

    const currentOption = _.find(options, option => {
        return option.value === field.value
    })
    
    return (
        sortedFilterItems.length !== 0 && <div className="control-select control-radio">
            <Select {...selectSettings}
                options={options}
                placeholder={<Translation id={'signage_filter_select_option_title'}/>}
                value={currentOption} 
                onChange={(value) => onChange(value, id)}
            />
        </div>
    )
}

export default SignageFilterSelect